export default {
    // 荷兰语
    LOCALE_HTML: {
        'msg.language': 'nl',
        'msg.title': 'titel',
        'msg.type': 'vraagcategorie',
        'msg.des': 'Probleembeschrijving',
        'msg.phone': 'Telefoonnummer',
        'msg.regionCode': 'Netnummer',
        'msg.email': 'Mail',
        'msg.choose':
            'Selecteer het bedrijf waarvoor u een bericht wilt achterlaten',
        'msg.detail': 'Berichtdetails',
        'msg.back': 'opbrengst',
        'your.msg': 'Jouw bericht',
        'msg.record': 'Berichtrecord',
        'msg.success': 'Bericht succesvol',
        'to.record': 'Ga naar berichtgeschiedenis',
        completed: 'Finish',
        submit: 'indienen',
        'success.desc':
            'Uw bericht is succesvol verzonden, bedankt voor uw feedback',
        'msg.form.input': 'kom binnen alstublieft',
        'msg.reply': 'antwoord',
        'comment.suc': 'Bedankt voor je recensie! ',
        'comment.fail': 'Inzending mislukt',
        'comment.placeholder':
            'Welkom om suggesties te doen voor onze diensten',
        'reply.suc': 'Succesvol verzonden! ',
        'reply.fail': 'Voer alstublieft uw antwoordinhoud in',
        'reply.placeholder': 'Voer alstublieft uw antwoordinhoud in',
        'msg.more': 'Bekijk meer',
        'msg.collapse': 'dichtbij',
        'msg.myservice': 'Mijn servicebeoordeling',
        'msg.evaluate': 'Servicebeoordeling',
        'msg.evaluateTitle': 'Servicebeoordeling',
        'msg.score': 'score:',
        'msg.remark': 'Opmerking:',
        'msg.status.created': 'Gemaakt',
        'msg.status.pending': 'in behandeling',
        'msg.status.processing': 'Accepteren',
        'msg.status.solved': 'voltooid',
        'msg.service.reply': 'Klantenservice antwoord',
        'msg.my.reply': 'jouw antwoord',
        'msg.toast.des': 'Probleemomschrijving is leeg',
        'msg.toast.type': 'Vraagcategorie is leeg',
        'msg.toast.title': 'titel is leeg',
        'msg.toast.none': 'Kan niet leeg zijn',
        'msg.toast.noAnnex': 'Upload de bijlage',
        'msg.toast.noEmail': 'E-mail mag niet leeg zijn',
        'msg.toast.noTel': 'Mobiel telefoonnummer mag niet leeg zijn',
        'msg.toast.noRegionCode': 'Het netnummer mag niet leeg zijn',
        'msg.toast.noZone': 'Selecteer een tijdzone',
        'msg.toast.noDateTime': 'Selecteer datum tijd',
        'msg.toast.email': 'Voer alstublieft uw geldige e-mailadres in',
        'msg.toast.tel': 'Voer alstublieft een geldig telefoonnummer in',
        'msg.toast.regionCode': 'Selecteer het netnummer',
        'msg.toast.num': 'Vul het juiste nummer in',
        'msg.toast.annex': 'Upload de bijlage',
        'msg.toast.char': 'Voer de juiste tekens in',
        'msg.list.none': 'Geen gegevens',
        'msg.form.choose': 'Gelieve te kiezen',
        'msg.form.chooseZone': 'Selecteer tijdzone',
        'msg.form.chooseTime': 'Kies tijd',
        'msg.form.chooseDate': 'Kies datum',
        'msg.form.sure': 'Zeker',
        'msg.form.search': 'zoekopdracht...',
        'msg.form.uploadError':
            'Het formaat van de geüploade bijlage voldoet niet aan de eisen',
        'msg.form.uploadXss':
            'Upload mislukt, bestandsinhoud bevat illegaal script',
        'msg.update.time': 'bijgewerkt op',
        'msg.replace.images': 'afbeelding',

        MSG016: 'opgelost',
        MSG017: 'onopgelost',
        MSG019: 'indienen',
        MSG072: 'De beoordelingstag mag niet leeg zijn!',
        MSG073: 'Het evaluatiewoord mag niet leeg zijn!',
        MSG074: 'Etiket:',
        MSG075: 'Is het opgelost:',
        MSG076: 'Selecteer of het probleem is opgelost',
        MSG015: 'Heeft dit ticket uw probleem opgelost?',

        'file.size.limit': 'De bestandsgrootte mag niet groter zijn dan 50 MB',
        'detail.file.limit': 'Tot 15 is de grootte niet groter dan 50M',
        'form.question.des.tip': 'Voer een beschrijving van het probleem in',
        'form.title.tip': 'Voer een titel in',
        'form.class.tip': 'Selecteer een vraagcategorie',
        'upload.file': 'Bijlage uploaden',
        'file.count.limit': 'Er kunnen maximaal 15 bijlagen worden geüpload',
        'select.search.placeholder': 'zoek op het trefwoord',
        'msg.form.sizeError1': 'Upload bijlagen van minder dan 5 miljoen',
        'msg.form.sizeError2': 'Upload bijlagen van minder dan 50 miljoen',
        'msg.form.submit': 'indienen...',
        'msg.form.upload': 'uploaden...',
        'msg.email.tip1': 'Uw bericht is niet gevonden',
        'msg.email.tip2':
            'Als je al eerder een bericht hebt achtergelaten, kun je dit controleren via e-mailverificatie',
        'msg.email.tip3': 'E-mailverificatie starten',
        'msg.email.noData': 'Er staan geen gegevens onder de betaalrekening',
        'email.verify.tip':
            'Vul het e-mailadres in dat u wilt gebruiken bij het achterlaten van een bericht',
        'email.input.placeholder': 'Vul het e-mailadres in',
        'email.submit': 'E-mail verzenden',
        'email.rules.error': 'Voer alstublieft uw geldige e-mailadres in',
        'email.code.tip':
            'De e-mail is verzonden, voer de ontvangen verificatiecode in',
        'email.code.placeholder': 'Voer a.u.b. de verificatiecode in',
        'email.code.submit': 'kijk nu',
        'email.notFind.customer': 'Geen klantgegevens gevonden',
        'email.code.wrong': 'Verificatiecodefout, voer deze opnieuw in',
        'email.code.expired':
            'Verificatiecode is verlopen, verifieer e-mail opnieuw',
        'email.code': 'Verificatie code',
        'email.send.frequently':
            'De handeling komt te vaak voor, probeer het later opnieuw',
        'comment.fail.400133': 'Het ticket is beoordeeld',
        'not.get.user.info': 'Kan uw gegevens niet verkrijgen',
        'user.verify.tip':
            'U moet controleren voordat u de inhoud van de berichtenlijst kunt bekijken',
        'verify.type.email': 'E-mailverificatie',
        'verify.text': 'valideren',
        'cancel.text': 'annuleren',
        'get.verify.code': 'Verificatiecode verkrijgen',
        'reGet.verify.code': 'Reacquire ',
        'verify.by.email.tip':
            'De verificatiecode wordt per e-mail verzonden naar het e-mailaccount dat u hebt ingevoerd',
        'verify.type.phone': 'SMS-verificatie',
        'phone.placeholder': 'Voer uw telefoonnummer in',
        'verify.by.phone.tip':
            'De verificatiecode wordt per sms verstuurd naar het telefoonnummer dat u hebt ingevoerd',
        'phone.error': 'Voer het juiste telefoonnummer in',
        'phone.errorCode400150': 'Regelmatige verzending van verificatiecodes',
        'phone.errorCode400233': 'De sms-sjabloon kan niet leeg zijn',
        'phone.errorCode400234': 'Onvoldoende marketingSMS-saldo',
        'phone.errorCode400235': 'SMS-saldo voor meldingen ontoereikend',
        'phone.errorCode400247': 'SMS-configuratiefout voor werkorderplugin',
        'phone.errorCode4400248': 'Kon sms-sjabloon niet verkrijgen',
        'phone.errorCode400249':
            'Dit nummer is niet het telefoonnummer van een bestaande gebruiker',
        'phone.errorCode400250':
            'De verificatiecode is verlopen, vraag deze opnieuw aan',
        'msg.you.reply': 'Ik heb je geantwoord',
        'msg.no.reply':'geen antwoord',
    },
    LOCALE_REQUEST: {
        400016: 'Het verkrijgen van werkorderinformatie is verlopen. Vernieuw alstublieft!'
    },
    LOCALE_SYSTEM: {
        MSG004: ({ name }) =>
            `Hallo, klantenservice ${name} heeft uw verzoek geaccepteerd`,
        MSG012: (color) =>
            ` jij kan <span style="color:${color};text-decoration:underline;" class="js-leave-msg">bericht achterlaten</span>`,
        MSG013: 'verzenden naar klantenservice'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'usuwać',
                cancel: 'Anulować',
                confirm: 'Jasne',
                inert: 'wstawić',
                width: 'szerokość',
                height: 'wysoki'
            },
            controls: {
                clear: 'jasna treść',
                undo: 'unieważnić',
                redo: 'przerobić',
                fontSize: 'rozmiar czcionki',
                lineHeight: 'Wysokość linii',
                letterSpacing: 'odstępy między wyrazami',
                textIndent: 'wcięcie akapitu',
                increaseIndent: 'zwiększyć wcięcie',
                decreaseIndent: 'zmniejszyć wcięcie',
                border: 'rama',
                color: 'kolor',
                textColor: 'kolor tekstu',
                backgroundColor: 'kolor tła',
                tempColors: 'tymczasowy kolor',
                bold: 'pogrubiony',
                italic: 'kursywa',
                underline: 'podkreślać',
                strikeThrough: 'przekreślenie',
                fontFamily: 'czcionka',
                textAlign: 'wyrównanie tekstu',
                alignLeft: 'lewy',
                alignCenter: 'w centrum',
                alignRight: 'Prawidłowy',
                alignJustify: 'oba zakończenia',
                floatLeft: 'pływać w lewo',
                floatRight: 'pływać w prawo',
                superScript: 'Napisany u góry',
                subScript: 'indeks',
                removeStyles: 'jasny styl',
                headings: 'tytuł',
                header: 'tytuł',
                normal: 'standardowy',
                orderedList: 'uporządkowana lista',
                unorderedList: 'lista nieuporządkowana',
                blockQuote: 'cytat',
                code: 'kod',
                link: 'Połączyć',
                unlink: 'jasne łącze',
                hr: 'linia pozioma',
                media: 'głoska bezdźwięczna',
                mediaLibirary: 'Biblioteka multimediów',
                emoji: 'Mały wyraz',
                fullscreen: 'pełny ekran',
                exitFullscreen: 'Wyłączyć tryb pełnoekranowy'
            },
            linkEditor: {
                textInputPlaceHolder: 'wprowadź tekst linku',
                linkInputPlaceHolder: 'Wpisz adres łącza',
                inputWithEnterPlaceHolder:
                    'Wprowadź adres łącza i naciśnij Enter',
                openInNewWindow: 'otworzyć w nowym oknie',
                removeLink: 'usuń link'
            },
            audioPlayer: {
                title: 'odtwórz plik audio'
            },
            videoPlayer: {
                title: 'odtwórz plik wideo',
                embedTitle: 'multimedia wbudowane'
            },
            media: {
                image: 'obraz',
                video: 'wideo',
                audio: 'audio',
                embed: 'multimedia wbudowane'
            }
        },
        finder: {
            remove: 'usuwać',
            cancel: 'Anulować',
            confirm: 'potwierdzać',
            insert: 'wstaw wybrany element',
            width: 'szerokość',
            height: 'wysoki',
            image: 'zdjęcie',
            video: 'wideo',
            audio: 'audio',
            embed: 'multimedia wbudowane',
            caption: 'Biblioteka multimediów',
            dragTip: 'Kliknij lub przeciągnij plik tutaj',
            dropTip: 'Zwolnij, aby przesłać',
            selectAll: 'Zaznacz wszystko',
            deselect: 'anulować wybór',
            removeSelected: 'usuń wybrany element',
            externalInputPlaceHolder: 'Nazwa zasobu|Adres zasobu',
            externalInputTip:
                'Użyj „|”, aby oddzielić nazwę zasobu od adresu zasobu',
            addLocalFile: 'Dodaj zasoby lokalne',
            addExternalSource: 'Dodaj zasób sieciowy',
            unnamedItem: 'projekt bez tytułu',
            confirmInsert: 'Wstaw wybrany element'
        }
    }
}
